import React, { Fragment } from 'react';
import { Form, Row, Col, Tabs, Table, Icon, Input, Modal, Button, message, Radio, Menu, Dropdown, AutoComplete, Carousel, Pagination, Select, Popover, Tooltip } from 'antd';
import BaseContaier from '../../../containers/base';
import Event from 'react-eventproxy';
import { CustomerQueue, QueueStatistics } from '../../../utils/websocket';
import moment from 'moment'
import API, { url } from '../../../utils/api'
import Common from '../../../components/common'

import Broadcast_icon from '../../../images/broadcast_icon.png'
import Record_icon from '../../../images/record_icon.png'
import Left_icon from '../../../images/left_icon.png'
import Right_icon from '../../../images/right_icon.png'
import Top_icon from '../../../images/top_icon.png';// 置顶
import Remarks_icon from '../../../images/remarks_icon.png';// 备注
import Cancel_mark_icon from '../../../images/cancel_mark_icon.png';
const { Option } = Select;


export default class extends BaseContaier {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
        }
    }

    componentDidMount() {
        this.getSceneSituation();
    }

    getSceneSituation = () => {
        // const hide = message.loading('请稍后 ...');
        const storeId = Common.getStoreInfo().storeId
        let params = {
            storeId: storeId,
        }
        this.Api.getIndex(params).then(res => {
            this.setState({
                projects: res,
            }, this.iStatisticsEvent)
        }).catch(e => {
            message.error(e || '服务器出现错误')
        })
    }

    iStatisticsEvent = () => {//排场情况消息推送
        const self = this;
        Event.on(QueueStatistics, ({ data, option }) => {
            let { projects } = self.state;
            if (option == 'update') {
                if (data && data.length > 0) {
                    for (let p = 0; p < projects.length; p++) {
                        let pItem = projects[p]
                        for (let d = 0; d < data.length; d++) {
                            let dItem = data[d]
                            if (pItem.gameId == dItem.gameId) {
                                pItem.gameSession = dItem.gameSession;
                                pItem.personNum = dItem.personNum;
                            }
                        }
                    }
                    self.setState({
                        projects
                    })
                }
            }
        });
    }

    render() {
        const { projects } = this.state;
        return (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Statistics dataProjects={projects} />
                <Queue />
            </div>

        );
    }

}
/**
 * 排场情况
 */
class Statistics extends React.Component {
    constructor(props) {
        super(props);
        this.lineUp = this.lineUp.bind(this);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.state = {
            lineUpType: false,
        }
    }

    //排场情况展示隐藏
    lineUp = () => {
        const { lineUpType } = this.state;
        this.setState({
            lineUpType: !lineUpType
        })
    }

    // 序列化游戏数组
    chunk = (arr, size) => {
        let arr2 = [];
        for (let i = 0; i < arr.length; i = i + size) {
            arr2.push(arr.slice(i, i + size));
        }
        return arr2;
    }

    //排场情况左右切换
    next = () => {
        this.slider.slick.slickNext();
    }

    prev = () => {
        this.slider.slick.slickPrev();
    }

    render() {
        const { dataProjects } = this.props;
        const a = dataProjects.length % 18
        const b = 18 - a
        if (a != 0) {
            for (let i = 0; i < b; i++) {
                dataProjects.push({ gameName: '', pNum: '', wTime: '' })
            }
        }
        const { lineUpType } = this.state;
        const dataProjectsList = this.chunk(dataProjects, 18)
        const offSW = document.querySelector('body').offsetWidth - 120;
        return (
            <div style={{ width: offSW, backgroundColor: '#242140', display: 'flex', flexDirection: 'column', padding: 20, borderRadius: 5, marginBottom: 20, overflow: 'hidden', position: 'relative', boxShadow: '10px 10px 10px 10px rgba(25,23,54,0.83)' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={this.lineUp}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={require('../../../images/pre_icon.png')} style={{ width: 24, height: 24 }} />
                        <span style={{ fontSize: 16, color: 'white', marginLeft: 14 }}>排场情况</span>
                    </div>
                    <img src={require(lineUpType ? '../../../images/up_icon.png' : '../../../images/down_icon.png')} style={{ width: 18, height: 18, }} />
                </div>
                {
                    lineUpType && dataProjects.length > 0 ? <div> <Button style={{ width: 40, height: 40, border: 'none', borderRadius: 20, background: `url(${Left_icon})`, backgroundSize: '100%', position: 'absolute', top: '50%', left: 10, zIndex: 99 }} onClick={this.next}></Button>
                        <Button style={{ width: 40, height: 40, border: 'none', borderRadius: 20, background: `url(${Right_icon})`, backgroundSize: '100%', position: 'absolute', top: '50%', right: 10, zIndex: 99 }} onClick={this.prev}></Button></div> : null
                }
                {
                    lineUpType ? <Carousel ref={el => (this.slider = el)} dots={false} id='homeLineupBar'>
                        {
                            dataProjectsList.map((item, index) => {
                                const projectChildList = this.chunk(item, 6);
                                return (
                                    <div key={`sss-${index}`}>
                                        <div style={{ display: "flex", flexDirection: 'row', flexWrap: 'wrap' }} key={`dataProject-${index}`}>
                                            {
                                                projectChildList.map((itemChild, index) => {
                                                    return (
                                                        <div style={{ flex: 1, marginTop: 10, borderRightColor: '#6E738E', borderRightWidth: index == projectChildList.length - 1 || itemChild[index].gameId == undefined ? 0 : 1, borderRightStyle: 'solid', paddingLeft: 70, paddingRight: 70, }} key={`projectChild-${index}`}>
                                                            {
                                                                itemChild[index].gameId ? <Row style={{ color: '#b7b3c9', marginBottom: 10, }} key={`itemChild-${index}`}>
                                                                    <Col span={12} style={{ paddingLeft: 20, textAlign: 'left', fontSize: 14, color: '#6E738E' }}>项目名称</Col>
                                                                    <Col span={6} style={{ textAlign: 'left', fontSize: 14, color: '#6E738E' }}>排队数量</Col>
                                                                    <Col span={6} style={{ textAlign: 'center', fontSize: 14, color: '#6E738E' }}>预计等待</Col>
                                                                </Row> : null
                                                            }
                                                            {
                                                                itemChild.map((child, index) => {
                                                                    return (
                                                                        child.gameId ? <Row style={{ backgroundColor: index % 2 == 0 ? '#1A1736' : '', height: 36, borderRadius: 16, display: 'flex', alignItems: 'center', flex: 1, }} key={`itemChild-${child.gameId}`}>
                                                                            <Col span={12} style={{ paddingLeft: 30, textAlign: 'left', fontSize: 14, color: '#fff' }}>{child.gameName}</Col>
                                                                            <Col span={6} style={{ paddingLeft: 15, textAlign: 'left', fontSize: 14, color: '#FFF' }}>{child.personNum}<span style={{ color: '#6E738E', marginLeft: 4 }}>人</span></Col>
                                                                            <Col span={6} style={{ textAlign: 'center', fontSize: 14, color: '#FFF' }}>{child.gameSession}<span style={{ color: '#6E738E', marginLeft: 4 }}>场</span></Col>
                                                                        </Row> : null
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Carousel> : null
                }
            </div>
        );
    }

}

/**
 * 队列池
 */
class Queue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: 1,
            customerUpType: true,
        }

    }

    // componentWillReceiveProps(nextProps) {
    //     if (nextProps !== this.props) {
    //         this.state = {
    //             dataHomeQueues: nextProps.dataHomeQueues,
    //             // dataSource: nextProps.dataHomeQueues.filter(item => item.queues.findIndex(game => game.queueStatus == 0) > -1,
    //             customerUpType: true,
    //         }
    //     }
    // }

    //顾客队列展示隐藏
    customerUp = () => {
        const { customerUpType } = this.state;
        this.setState({
            customerUpType: !customerUpType
        })
    }

    render() {
        const { customerUpType } = this.state;
        return (
            <div style={{ backgroundColor: '#242140', padding: 20, borderRadius: 5, boxShadow: '10px 10px 10px 10px rgba(25,23,54,0.83)' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={this.customerUp} >
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={require('../../../images/customerQueue_icon.png')} style={{ width: 24, height: 24 }} />
                        <span style={{ fontSize: 16, color: 'white', marginLeft: 14 }}>顾客队列</span>
                    </div>
                    <img src={require(customerUpType ? '../../../images/up_icon.png' : '../../../images/down_icon.png')} style={{ width: 18, height: 18, }} />
                </div>
                {
                    customerUpType ? <PlayerList /> : null
                }
            </div>
        );
    }

}


/**
 * 手环列表
 */
class PlayerList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataHomeQueues: [],
            search: '',
            flag: 2,
            pageNum: 1,
            keyword: '',
            total: 0,
            pageSize: 30,
        }
    }

    // 叫号记录打开module
    onShowCallNumberModule = () => {
        this.itemFullModal.showModal({});
    }

    componentDidMount() {
        this.getCustomerQueue();
        this.projectEvent();
        window.addEventListener('scroll', this.bindHandleScroll)
    }

    componentWillUnmount() {
     window.removeEventListener('scroll', this.bindHandleScroll);
    }

    bindHandleScroll = (event) => {
        let self = this
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        // console.log('scrollHeight='+document.documentElement.scrollHeight,'scrollTop='+scrollTop,'clientHeight='+document.documentElement.clientHeight)
        if (document.documentElement.scrollHeight <= document.documentElement.clientHeight + scrollTop + 10) {
            const { total, pageNum, pageSize } = self.state
            const newTotal = pageNum * pageSize
            if (newTotal < total) {
                self.setState({
                    pageNum: pageNum + 1
                })
                self.getCustomerQueue()
            }
        }
    }

    //获取顾客队列数据
    getCustomerQueue = (dataType) => {
        const hide = message.loading('请稍后 ...');
        const storeId = Common.getStoreInfo().storeId
        const { flag, keyword, dataHomeQueues, pageNum, pageSize } = this.state
        let params = {
            storeId: storeId,
            flag,
            pageSize,
            pageNum,
            keyword,
        }
        API.getCustomerQueue(params).then(res => {
            // debugger
            let arr2 = []
            res.list.map((item, index) => {
                arr2.push(
                    Object.assign({}, item, { bOk: false })
                )
                item.projects.map((it, index) => {
                    it.mode = false
                })
            })
            this.setState({
                total: res.total,
                dataHomeQueues: dataHomeQueues.concat(arr2),
            },)
            hide();
        }).catch(e => {
            message.error(e || '服务器出现错误')
            hide();
        })
    }

    /**
     * websocket消息推送
     */
    projectEvent = () => {
        const self = this;
        Event.on(CustomerQueue, ({ data, option }) => {
            // console.log('顾客队列推送', option)
            if (option == 'topOne') {// 置顶
                if (data && data.length > 0) {
                    let newArr = [...self.state.dataHomeQueues];
                    let indexs = [];
                    newArr.forEach((d, index) => {
                        if (data[0].queueId == d.queueId) {
                            indexs.push(index);
                        }
                    });
                    let _newArr = newArr.filter((item, index) => indexs.findIndex(is => is == index) <= -1);
                    let nextArr = [];
                    let isInsert = false;
                    _newArr.forEach((item, index) => {
                        if (item.sort <= data[0].sort && !isInsert) {
                            nextArr.push(data[0]);
                            nextArr.push(item);
                            isInsert = true;
                        } else {
                            nextArr.push(item);
                        }
                    });
                    self.setState({
                        dataHomeQueues: nextArr
                    })
                }
            }
            if (option == 'add') {//添加顾客队列
                if (data && data.length > 0) {
                    let _newArr = [...self.state.dataHomeQueues];
                    let nextArr = [];
                    let isInsert = false;
                    _newArr.forEach((item, index) => {
                        if (item.sort <= data[0].sort && !isInsert) {
                            nextArr.push(data[0]);
                            nextArr.push(item);
                            isInsert = true;
                        } else {
                            nextArr.push(item);
                        }
                    });
                    self.setState({
                        dataHomeQueues: nextArr
                    })
                }
            }
            if (option == 'update') {//备注优先级、客户状态、开始游戏、
                if (data && data.length > 0) {
                    // console.log(data)
                    let newArr = [...self.state.dataHomeQueues];
                    for (let n = 0; n < newArr.length; n++) {
                        let nItem = newArr[n]
                        for (let i = 0; i < data.length; i++) {
                            let iTiem = data[i]
                            // console.log(iTiem)
                            if (nItem.queueId == iTiem.queueId) {
                                nItem.customerStatus = iTiem.customerStatus;
                                nItem.priority = iTiem.priority;
                                nItem.projects = iTiem.projects;
                            }
                        }
                    }
                    newArr.map((item, index) => {
                        item.projects.map((em, index) => {
                            em.mode = false
                        })
                    })
                    self.setState({
                        dataHomeQueues: newArr
                    })
                }
                if (data.option == 'cancelQueue') {//取消排队
                    let newArr = [...self.state.dataHomeQueues];
                    newArr.forEach((item, index) => {
                        if (item.queueId == data.areaQueueGameList.queueId) {
                            for (let i = 0; i < item.projects.length; i++) {
                                let itemIndex = item.projects[i]
                                if (itemIndex.queueGameId == data.areaQueueGameList.queueGameId) {
                                    itemIndex.areaName = '',
                                        itemIndex['BtnType'] = 'true'
                                }
                            }
                        }
                    })
                    self.setState({
                        dataHomeQueues: newArr
                    })
                }
            }
        });
    }


    //  待体验/已体验
    changeTab = (value) => {
        // console.log(value)
        this.setState({
            flag: value,
            pageNum: 1,
            dataHomeQueues: [],
        }, this.getCustomerQueue)
    }

    //置顶
    meadTop = (queueId, key) => {
        const storeId = Common.getStoreInfo().storeId;
        const TopType = key == 0 ? '置顶' : '取消置顶'
        const params = {
            queueId,
            storeId
        }
        API.meadTops(params).then(res => {
            // this.getCustomerQueue();
            message.success(`${TopType}成功`)
        }).catch(e => {
            message.error(`${TopType}失败:${e}`);
        })
    }

    //取消排队记录
    cancelViewShowHide = (a, b) => {
        const { dataHomeQueues } = this.state
        const storeId = Common.getStoreInfo().storeId;
        let _acData = dataHomeQueues.find(x => x.queueId == a);
        let acData_ = dataHomeQueues.filter(x => x.queueId != a);
        API.cancelHosity(storeId, a).then(res => {
            // debugger
            let arrs = []
            dataHomeQueues.map((item, index) => {
                arrs.push(
                    Object.assign({}, item, { canceArray: res })
                )
            })
            this.setState({
                dataHomeQueues: arrs
            })
        }).catch(e => {
            message.error(`查询失败:${e}`);
        })
        // console.log(a,b)
        _acData.bOk = !b
        for (let s = 0; s < _acData.projects.length; s++) {
            let itemIndex = _acData.projects[s]
            if (itemIndex.BtnType) {
                delete itemIndex.BtnType
            }
        }
        acData_.map((item, index) => {
            item.bOk = false
        })
        this.setState({
            dataHomeQueues
        })
    }

    //备注客户优先级
    priorityMarks = (queueId, priority) => {
        return (
            <div style={{ width: 142, height: 50, backgroundColor: '#1A1736', display: 'flex', justifyContent: 'space-around', alignItems: 'center', flexDirection: 'row', padding: '0 20px', borderRadius: 5,}}>
                <div style={{ width: 18, height: 18, backgroundColor: '#E42727', borderRadius: 5, cursor: 'pointer', border: priority == 4 ? '1px solid #fff' : 'none', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', padding: '2px 3px', }} onClick={() => { this.ChangepriorityMarks(4, queueId) }}>
                    {
                        priority == 4 ? <Icon type="check" style={{ width: 10, height: 10 }} /> : null
                    }
                </div>
                <div style={{ width: 18, height: 18, backgroundColor: '#FF7800', borderRadius: 5, cursor: 'pointer', border: priority == 3 ? '1px solid #fff' : 'none', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', padding: '2px 3px', }} onClick={() => { this.ChangepriorityMarks(3, queueId) }}>
                    {
                        priority == 3 ? <Icon type="check" style={{ width: 10, height: 10 }} /> : null
                    }
                </div>
                <div style={{ width: 18, height: 18, backgroundColor: '#FFEB3B', borderRadius: 5, cursor: 'pointer', border: priority == 2 ? '1px solid #fff' : 'none', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', padding: '2px 3px', }} onClick={() => { this.ChangepriorityMarks(2, queueId) }}>
                    {
                        priority == 2 ? <Icon type="check" style={{ width: 10, height: 10 }} /> : null
                    }
                </div>
                <div style={{ width: 18, height: 18, backgroundColor: '#BDBDBD', borderRadius: 5, cursor: 'pointer', border: priority == 1 ? '1px solid #fff' : 'none', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', padding: '2px 3px', }} onClick={() => { this.ChangepriorityMarks(1, queueId) }}>
                    {
                        priority == 1 ? <Icon type="check" style={{ width: 10, height: 10 }} /> : null
                    }
                </div>
            </div>
        )
    }

    // 备注客户优先级
    ChangepriorityMarks = (key, value) => {
        const storeId = Common.getStoreInfo().storeId;
        let params = {
            storeId,
            queueIds: value,
            priority: key,
        }
        API.upDatePriorityMarks(params).then(res => {
            message.success(`备注优先级成功`)
        }).catch(e => {
            message.error(`查询失败:${e}`);
        })
    }

    // 排队叫号
    callNumberPlay = () => {
        const storeId = Common.getStoreInfo().storeId
        const { dataHomeQueues, } = this.state;
        let arrs = []
        // debugger
        dataHomeQueues.map((item, index) => {
            item.projects.map((it, index) => {
                if (it.mode == true) {
                    arrs.push({ 'storeId': storeId, 'customerNum': item.customerNum, 'areaId': it.areaId, 'gameName': it.gameName,'gameId':it.gameId, 'areaName': it.areaName })
                }
            })
        })
        if (arrs.length == 0) {
            message.error('未选取用户')
            return
        }
        API.eCallnumber(arrs).then(res => {
            message.success('叫号成功')
        }).catch(e => {
            message.error('叫号失败,' + e);
        })
        dataHomeQueues.map((item, index) => {
            item.projects.map((em, index) => {
                em.mode = false
            })
        })
        this.setState({
            dataHomeQueues
        })
    }

    // 监听回车事件
    onKeyUp = (e) => {
        let self = this
        if (e.keyCode === 13) {
            self.setState({
                pageNum: 1,
                dataHomeQueues: []
            })
            setTimeout(() => {
                self.getCustomerQueue()
            }, 100)
        }
    }

    render() {
        const { dataHomeQueues, flag } = this.state;
        const offSH = document.querySelector('body').clientHeight - 300;
        const rowStyle = { display: 'flex', flex: 1, justifyContent: 'center', backgroundColor: '#242140', borderRadius: 5, color: 'white', };
        //修改客户状态
        const onClick = ({ param, queueId }) => {
            const customerStatus = param.key;
            let params = {
                customerStatus,
                queueId
            }
            //发起网络请求 修改顾客状态
            API.updateGuestStatusType(params).then(res => {
                //刷新页面
                message.success('修改成功')
            }).catch(e => {
                message.error(`修改失败:${e}`);
            })
        };
        return (
            <div style={{ flex: 1, backgroundColor: '#242140', paddingBottom: 10 }} id='customerInputStyle'>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingTop: 15, paddingBottom: 15, }}>
                    <div style={{ backgroundColor: '#242140', display: 'flex', flexDirection: 'row' }}>
                        <Select defaultValue={flag == 2 ? "待体验" : '已体验'} dropdownStyle={{ backgroundColor: "#272547", boxShadow: '4px 4px 4px 4px rgba(21,19,46,0.52)' }} onChange={(value) => { this.changeTab(value) }} suffixIcon={<Icon type="caret-down" />}>
                            <Option value="2" style={{ padding: '8px 12px', color: '#FFF', fontSize: 14, backgroundColor: flag == 2 ? '#342f51' : '' }}>待体验
                            </Option>
                            <Option value="1" style={{ padding: '8px 12px', color: '#FFF', fontSize: 14, backgroundColor: flag == 1 ? '#342f51' : '' }}>已体验
                            </Option>
                        </Select>
                        <Input placeholder="请输入顾客编号"
                            onChange={(e) => {
                                this.setState({
                                    keyword: e.currentTarget.value
                                })
                            }}

                            allowClear={true}
                            style={{ marginLeft: 40, width: 388, height: 40, backgroundColor: '#1A1736', borderRadius: 20, border: 'none', color: '#6E738E' }} onKeyUp={this.onKeyUp}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Tooltip title='排队叫号' trigger={['hover', 'click']}>
                            <Button style={{ width: 40, height: 40, border: 'none', borderRadius: 20, background: `url(${Broadcast_icon})`, backgroundSize: '100%', }} onClick={() => { this.callNumberPlay() }}></Button>
                        </Tooltip>
                        <Tooltip title='排队叫号记录' placement="bottomRight">
                            <Button style={{ width: 40, height: 40, border: 'none', marginLeft: 20, borderRadius: 20, background: `url(${Record_icon})`, backgroundSize: '100%' }} onClick={this.onShowCallNumberModule}></Button>
                        </Tooltip>
                        <CallNumberRecordModal ref={o => this.itemFullModal = o} />
                    </div>
                </div>

                <Row style={{ ...rowStyle, color: '#b7b3c9' }}>
                    <Col span={2} style={{ paddingLeft: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6E738E', fontSize: 14, }}>顾客编号</Col>
                    <Col span={14} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6E738E', fontSize: 14, padding: '10px 0' }}>体验项目</Col>
                    <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6E738E', fontSize: 14 }}>顾客状态</Col>
                    <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6E738E', fontSize: 14 }}>操作</Col>
                </Row>
                <div style={{ minHeight: offSH, }} className='customerView'>
                    {
                        dataHomeQueues && dataHomeQueues.map((item, index) => {
                            return (
                                <div key={`loiu_${item.queueId}`}>
                                    <Row style={{ ...rowStyle, backgroundColor: index % 2 == 0 ? '#1A1736' : '', }} key={item.queueId}>
                                        <Col span={2} style={{ verticalAlign: 'middle', alignItems: 'center', display: 'flex', fontWeight: 'bold', fontSize: 16, flexDirection: 'column', justifyContent: 'center', position: 'relative' }}>
                                            <div style={{ width: 4, height: '100%', backgroundColor: item.priority == 1 ? '' : item.priority == 2 ? '#FFEB3B' : item.priority == 3 ? '#FF7800' : '#E42727', position: 'absolute', top: 0, left: 0, borderRadius: '5px 0 0 5px' }}></div>
                                            {
                                                item.sort != 0 ? <img src={require('../../../images/meadTop_icon.png')} style={{ width: 30, height: 30, position: 'absolute', top: 0, left: item.priority == 1 ? 0 : 4, zIndex: 88, }} /> : null
                                            }
                                            <span style={{ fontSize: 14 }}>{item.customerNum}</span>
                                            {
                                                item.teamId ? <span style={{ fontSize: 12, color: '#6E738E' }}>{`TEAM ${item.teamId}`}</span> : null
                                            }
                                        </Col>
                                        <Col span={14} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', padding: '15px 0' }}>
                                            <GameListItem textColor='white' games={item.projects} onClickDropList={() => {
                                                this.cancelViewShowHide(item.queueId, item.bOk)
                                            }} />
                                        </Col>
                                        <Col span={4} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', padding: '15px 0' }}>
                                            <Dropdown overlay={(<MenuList onPress={(param) => { onClick({ param, queueId: item.queueId }) }} customerStatus={item.customerStatus} />)}>
                                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '5px 10px', backgroundColor: '#333053', borderRadius: 16, cursor: 'pointer' }}>
                                                    <img src={require(item.customerStatus == 1 ? '../../../images/customer_icon.png' : item.customerStatus == 2 ? '../../../images/clientele_icon.png' : item.customerStatus == 3 ? '../../../images/leagueBuilding_icon.png' : '../../../images/leavingShop_icon.png')} style={{ width: 16, height: 16, borderRadius: 8, marginRight: 5 }} />
                                                    <span style={{ color: item.customerStatus == 4 ? '#646884' : '#FFFFFF' }}>{item.customerStatus == 1 ? '顾客' : item.customerStatus == 2 ? '客户' : item.customerStatus == 3 ? '团建' : '离店'}</span>
                                                    <div style={{ width: 0, height: 0, borderLeft: '4px solid transparent', borderRight: '4px solid transparent', borderTop: `4px solid ${item.customerStatus == 4 ? '#646884' : '#FFFFFF'}`, marginLeft: 5 }}></div>
                                                </div>
                                            </Dropdown>
                                        </Col>
                                        <Col span={4} style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-around', alignItems: 'center', padding: '15px 0' }}>
                                            <Tooltip trigger={['hover', 'click']} title='置顶'>
                                                <div style={{ width: 24, height: 24, cursor: 'pointer', background: `url(${Top_icon})`, backgroundSize: '100%', }} onClick={() => { this.meadTop(item.queueId, item.sort) }}></div>
                                            </Tooltip>
                                            <Tooltip trigger={['hover', 'click']} title='点击查看取消排队信息'>
                                                <div style={{ cursor: 'pointer', }} onClick={() => { this.cancelViewShowHide(item.queueId, item.bOk) }} key={`sada-${index}`}>
                                                    {
                                                        item.bOk ? <img style={{ width: 24, height: 24, }} src={Cancel_mark_icon}></img> : <img style={{ width: 24, height: 24, }} src={require('../../../images/cancel_icon.png')}></img>
                                                    }
                                                </div>
                                            </Tooltip>
                                            <Tooltip trigger={['hover', 'click']} title='优先级备注'>
                                                <Popover placement="bottom" trigger="click" content={this.priorityMarks(item.queueId, item.priority)}>
                                                    <div style={{ width: 24, height: 24, cursor: 'pointer', background: `url(${Remarks_icon})`, backgroundSize: '100%', }}></div>
                                                </Popover>
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                    {
                                        item.bOk ? <div style={{ display: "flex", flex: 1, backgroundColor: '#1A1736', marginTop: 5, marginBottom: 5, padding: '10px 20px', borderRadius: 5, flexDirection: 'column' }} key={`has_${item.queueId}`}>
                                            <div style={{ fontSize: 14, color: '#fff' }}>取消排队列表</div>
                                            {
                                                item.canceArray && item.canceArray.length > 0 ? (
                                                    item.canceArray.map((T, index) => {
                                                        return <Row style={{ borderBottomWidth: item.canceArray.length - 1 == index ? 0 : 1, borderBottomColor: '#646884', borderBottomStyle: 'solid', padding: '5px 0' }} key={`qwer-${index}`}>
                                                            <Col span={2} style={{ textAlign: 'center', color: 'white', fontSize: 14 }}>{index + 1}</Col>
                                                            <Col span={3} style={{ textAlign: 'center', color: 'white', fontSize: 14 }}>{T.gameName}</Col>
                                                            <Col span={15} style={{ textAlign: 'center', color: 'white', fontSize: 14 }}>{T.areaName}</Col>
                                                            <Col span={4} style={{ textAlign: 'center', color: 'white', fontSize: 14 }}>{moment(T.createTime).format("YYYY-MM-DD HH:mm:ss")}</Col>
                                                        </Row>
                                                    })
                                                ) : null
                                            }
                                        </div> : null
                                    }

                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }

}
class MenuList extends React.Component {
    static defaultProps = {
        item: null
    }

    SelectedMark = () => {
        return <img style={{ marginLeft: 40, width: 20, height: 20 }} src={require('../../../images/Check_mark_icon.png')}></img>
    }

    render() {
        const { customerStatus } = this.props
        return (
            <div style={{ boxShadow: '4px 4px 4px 4px rgba(21,19,46,0.3)', borderRadius: 8, }}>
                <Menu style={{ backgroundColor: '#272547', borderRadius: 8, marginTop: 6, paddingTop: 5, paddingBottom: 5 }} onClick={(param) => { this.props.onPress(param) }}>
                    <Menu.Item key="1" style={{ color: 'white', fontSize: 14, backgroundColor: customerStatus == 1 ? '#342f51' : '#272547' }}>顾客{customerStatus == 1 ? this.SelectedMark() : null}</Menu.Item>
                    <Menu.Item key="2" style={{ color: 'white', fontSize: 14, backgroundColor: customerStatus == 2 ? '#342f51' : '#272547' }}>客户{customerStatus == 2 ? this.SelectedMark() : null}</Menu.Item>
                    <Menu.Item key="3" style={{ color: 'white', fontSize: 14, backgroundColor: customerStatus == 3 ? '#342f51' : '#272547' }}>团建{customerStatus == 3 ? this.SelectedMark() : null}</Menu.Item>
                    <Menu.Item key="4" style={{ color: 'white', fontSize: 14, backgroundColor: customerStatus == 4 ? '#342f51' : '#272547' }}>离店{customerStatus == 4 ? this.SelectedMark() : null}</Menu.Item>
                </Menu>
            </div>
        );
    }

}

/**
 * 叫号记录 组件
 */
class CallNumberRecordModal extends BaseContaier {
    state = {
        visible: false,
        oraderDatas: [],
        pageSize: 10,
        pageNum: 1,
        total: 0
    };

    showModal = () => {
        this.getFlowList(1)
    };

    getFlowList = (pageNum) => {
        const { pageSize } = this.state;
        const storeId = Common.getStoreInfo().storeId;
        let body = {
            pageSize,
            pageNum,
            storeId
        }
        this.Api.callNumberRecord(body).then(res => {
            this.setState({
                visible: true,
                oraderDatas: res.list,
                total: res.total,
                pageNum
            });
        }).catch(e => {
            message.error(e)
        })
    }

    hideModal = () => {

        this.setState({
            visible: false,
        });
    };

    getTableColumns = () => {
        return [
            {
                title: '序号',
                dataIndex: 'number',
                key: 'number',
                align: 'center',
            },
            {
                title: '顾客编号',
                dataIndex: 'customerNum',
                key: 'customerNum',
                align: 'center',
            },
            {
                title: '体验项目',
                dataIndex: 'itemArea',
                key: 'itemArea',
                align: 'center',
            },
            {
                title: '叫号时间',
                dataIndex: 'createTime',
                key: 'createTime',
                align: 'center',
                render: (createTime) => {
                    return moment(createTime).format("YYYY-MM-DD HH:mm:ss")
                }
            },
        ]
    }

    makeDataSource = (dataSource) => {
        let ds = [];
        const { pageNum, pageSize } = this.state;
        if (dataSource && dataSource.length > 0) {
            dataSource.forEach((item, index) => {
                item.number = (pageNum - 1) * pageSize + (index + 1);
            })
            ds = [...dataSource];
        }
        return ds;
    }

    /**
     * 下一页
     */
    onPageIndexChange = (pageIndex) => {
        this.getFlowList(pageIndex);
    }

    render() {
        const { pageSize, pageNum, oraderDatas, total } = this.state
        const dataSource = this.makeDataSource(oraderDatas);
        return (
            <div style={{ backgroundColor: '#292646', }}>
                <Modal
                    destroyOnClose={true}
                    title="叫号记录"
                    visible={this.state.visible}
                    onCancel={this.hideModal}
                    width={'60%'}
                    bodyStyle={{ backgroundColor: '#292646', borderRadius: 5, }}
                    footer={null}
                >
                    <div style={{ padding: '0 25px' }}>
                        <Table
                            rowKey={(record) => record.id}
                            style={{ backgroundColor: '#292646' }}
                            dataSource={dataSource}
                            columns={this.getTableColumns()}
                            bordered={false}
                            rowClassName={() => 'editable-row'}
                            pagination={false}
                        />
                        <div style={{ fontSize: 12, color: '#FFF', marginTop: 10 }}>提示：叫号记录仅展示最近100条。</div>
                        {
                            oraderDatas && oraderDatas.length > 0 ? (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Pagination current={pageNum} pageSize={pageSize} defaultPageSize={pageSize} onChange={this.onPageIndexChange} total={total} />
                                </div>
                            ) : null
                        }
                    </div>
                </Modal>
            </div>
        );
    }

}

/**
 * 每个队列的游戏项
 */
class GameListItem extends React.Component {
    static defaultProps = {
        games: [],
        mode: 'checkbox', // delete | checkbox
        checkboxreadonly: '', // true | false * 在 mode = checkbox 下 起作用
        teamId: ''
    }

    render() {
        const { games, onClickDropList } = this.props;
        // console.log(games)
        return (
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }} >
                {
                    games.map((game, index) => {
                        return <FormGameItem key={`game_${index}`} info={game} itemKey={game.gameId} onClickDropList={onClickDropList} />
                    })
                }
            </div>
        );
    }
}

/**
 * 动态表单的 游戏项
 */
class FormGameItem extends BaseContaier {

    constructor(props) {
        super(props);
        const { info, itemKey, } = this.props;
        this.onChange = this.onChange.bind(this);
        this.state = {
            info,
            itemKey,
        };
    }

    onChange = (choseType) => {
        // console.log(choseType)
        const { info } = this.props
        info.mode = !choseType;
        this.setState({
            info
        })
    }

    render() {
        const { onClickDropList,info  } = this.props;
        const { itemKey,} = this.state
        const checkBoxStyle = { fontSize: 18, fontWeight: 'bold', };
        const divStyle = { minHeight: 40, padding: '0 15px', color: 'white', display: 'flex', flexDirection: 'row', alignItems: 'center', }
        // console.log(info)
        return (
            info.status == 0 ? <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ ...divStyle, cursor: 'pointer' }} key={itemKey} onClick={() => { this.onChange(info.mode) }}>
                    <div style={{ background: info.mode == true ? '#fff' : '', lineHeight: 0, width: 15, height: 15, padding: 0, margin: 0, position: 'relative' }}>
                        {
                            info.mode == true ? <Icon type="check-square" theme="filled" style={{ ...checkBoxStyle, color: '#22E6A3', position: 'absolute', top: -1, left: -1 }} /> : <Icon type="border" style={{ ...checkBoxStyle, color: 'white', position: 'absolute', top: -1, left: -1 }} />
                        }
                    </div>
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span style={{ marginLeft: 10, color: "white", fontSize: 14, }}>{info.gameName}</span>
                        {
                            info.areaId != 0 ? <div><span style={{ fontSize: 14, marginLeft: 5, color: "#FFF" }}>
                                {`(${info.areaName})`}</span></div> : null
                        }
                    </div>
                </div>
            </div> : <div style={{ ...divStyle, cursor: 'pointer' }} key={itemKey} >
                    <Icon type="border" style={{ ...checkBoxStyle, color: '#6E738E', }} />
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                        <span style={{ marginLeft: 5, color: info.status == 1 ? '#fff' : '#6E738E' }}>{info.gameName}</span>
                        {
                            info.areaId != 0 ? <div><span style={{ fontSize: 14, marginLeft: 5, color: "#6E738E" }}>
                                {`(${info.areaName})`}</span></div> : null
                        }
                    </div>
                    {
                        info.BtnType ? <Tooltip trigger={['hover', 'click']} title='点击查看取消排队信息' onClick={() => { onClickDropList() }}> <Icon type="exclamation-circle" theme="filled" style={{ marginLeft: 5, marginTop: 2, color: '#E42727', cursor: 'pointer', }} /></Tooltip> : null
                    }

                </div>
        );
    }

}